import { useEffect, useState } from 'react';

const LandingPagePaginationService = (
  filteredEntities,
  isUserOnBulkSelectMode
) => {
  const [pageCount, setPageCount] = useState(1);
  const [pageIndex, setPageIndex] = useState(1);
  // Change this to what ever the API request length desired
  const [pagRange, setPagRange] = useState(500);
  const [resArrayLength, setResArrayLength] = useState(1);
  const [paginatedEntities, setPaginatedEntities] = useState(null);

  const startItem = (pageIndex - 1) * pagRange;
  const endItem = pageIndex * pagRange;

  useEffect(() => {
    setPageCount(Math.ceil(resArrayLength / pagRange));
  }, [pagRange, resArrayLength, filteredEntities]);

  useEffect(() => {
    if (isUserOnBulkSelectMode) {
      setResArrayLength(filteredEntities?.result?.roles?.length);
      setPaginatedEntities(
        filteredEntities?.result?.roles?.slice(startItem, endItem)
      );
    } else {
      setResArrayLength(filteredEntities?.result?.userAccesses?.length);
      setPaginatedEntities(
        filteredEntities?.result?.userAccesses?.slice(startItem, endItem)
      );
    }

    // Return to page 1 when a filter is applied
    setPageIndex(1);
  }, [filteredEntities]);

  useEffect(() => {
    if (isUserOnBulkSelectMode) {
      setPaginatedEntities(
        filteredEntities?.result?.roles?.slice(startItem, endItem)
      );
    } else {
      setPaginatedEntities(
        filteredEntities?.result?.userAccesses?.slice(startItem, endItem)
      );
    }
  }, [pageIndex, pagRange]);

  useEffect(() => {
    setPageIndex(1);
  }, [pagRange]);

  return {
    pageCount,
    pageIndex,
    setPageIndex,
    pagRange,
    setPagRange,
    resArrayLength,
    paginatedEntities,
    setPaginatedEntities,
  };
};

export default LandingPagePaginationService;
